/** "SAR 50" / "JOD 12.345": the admin UI is English; Latin digits, trailing zeros trimmed. */
export const DECIMALS = { SAR: 2, JOD: 3, EGP: 2 };

export function formatAmount(amount, currency) {
  if (amount === null || amount === undefined || amount === '') return '—';
  const dec = DECIMALS[String(currency || '').toUpperCase()] ?? 2;
  let n = Number(amount).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: dec });
  return currency ? `${String(currency).toUpperCase()} ${n}` : n;
}
